import { bannerData } from "../../features/createBanner/bannerTypes";
import { reduxEventState } from "../reducers/eventReducer";
import store from "../store";

export function setEventState(eventState: reduxEventState){
    store.dispatch({
        type: "setEventState",
        payload: eventState
    })
}
